import { render, staticRenderFns } from "./CellBadges.vue?vue&type=template&id=e682477e&"
import script from "./CellBadges.vue?vue&type=script&lang=js&"
export * from "./CellBadges.vue?vue&type=script&lang=js&"
import style0 from "./CellBadges.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports